export default function(state=true, action) {

    switch(action.type) {
        case "TOGGLE_FORM":
            return action.payload;

        case "OPTION_SELECTED": 
            return true

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerToggleForm.js